import { Feature } from '@tencent/workbench';
import BaseTitleBarFeature from '@framework/workbench/common/feature/base-titlebar-feature';
import { LINK } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { SlideBaseAppServices } from '@src/slide/application/entry/toc/base/slide-base-app-services';
import { openUrlForAll } from '@src/slide/infrastructure/module/independent/url/open-url';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

@Feature()
export class HelpAndFeedbackFeature extends BaseTitleBarFeature {
    public showHelp() {
        openUrlForAll({
            url: LINK.HELP_CENTER,
            replace: false,
            windowName: '_blank',
        });
    }

    public showReport() {
        this.getAppService().viewableServiceLayer.accusationService.promise().then((accusationService) => {
            accusationService.showSupportPage();
        });
    }

    public showAccusation() {
        this.getAppService().viewableServiceLayer.accusationService.promise().then((accusationService) => {
            accusationService.showJuBaoPage();
        });
    }

    public showPrivacyPolicy() {
        this.commonOpenPage('/doc/p/30cb57a3280b16bd48fb49001022ada97479339a?dver=2.1.0');
    }

    public showThirdPartyDataSharing() {
        this.commonOpenPage('/doc/p/e2ace9137ef7ec29008026d824100cc65be95035?dver=2.1.27232530');
    }

    public showThirdAuthorizationManagement() {
        this.commonOpenPage('/open/auth');
    }

    public showPersonalInfoCollection() {
        this.commonOpenPage('/doc/p/3b224d79afd8fbb47477ce2c9f867c7665b6cd05?dver=2.1.27277463');
    }

    public showInfringement() {
        // 侵权指引入口
        const url = `https://${window.hostname}/doc/DYWhSRFFtQWdsY2hx?pub=1&dver=2.1.0`;
        const options = {
            url,
            replace: false,
            windowName: '_blank',
        };
        openUrlForAll(options);
    }

    public showAppeal() {
        // 跳转到申诉页面
        location.href = `https://${window.hostname}/scenario/appeal.html?appealRefer=${encodeURIComponent(location.href)}`;
    }

    public showAbout() {
        this.commonOpenPage('/doc/DZElNVGl2aFBXcm1Z?pub=1&dver=2.1.0');
    }

    public showCommunityConvention() {
        // 跳转到平台公约
        this.commonOpenPage('/doc/p/9268f18064fb05baeab662ce62a2c8783225c276?dver=2.1.27348920');
    }

    public showShortCutKeyPanel() {
        const { editableServiceLayer } = this.getAppService() as unknown as IPcEditorAppServices;
        editableServiceLayer?.shortcutPanelManager?.promise().then((module) => {
            module?.show?.();
        });
    }

    private commonOpenPage(path: string) {
        openUrlForAll({
            url: `${window.location.origin}${path}`,
            replace: false,
            windowName: '_blank',
        });
    }

    private getAppService() {
        return AppServiceProvider.getInstance().getAppServices() as SlideBaseAppServices;
    }
}
